import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Search from "./components/Search";
import './App.css';

function App() {

  return (
    <div className="App">
      <Search/>
    </div>
  );
}

export default App;
